import { useChat as useSharedChat } from '@avanta/shared/hooks/useChat';
import { useUserStore } from 'stores/user';

export const useChat = (userId?: string): ReturnType<typeof useSharedChat> => {
  const currentUser = useUserStore(state => state.user);

  return useSharedChat({ currentUser, userId });
};
